import React from "react";
import * as CountryFlags from "country-flag-icons/react/3x2";

export default function CountryFlag({ countryCode, className = "", ...props }) {
  const normalizedCountryCode = String(countryCode || "").trim().toUpperCase();
  const Flag = CountryFlags[normalizedCountryCode];

  if (!Flag) {
    return null;
  }

  const classes = ["ds-country-flag", className].filter(Boolean).join(" ");

  return (
    <Flag
      className={classes}
      aria-hidden="true"
      focusable="false"
      {...props}
    />
  );
}
